import Vue from 'vue'
import App from './App.vue'

// Get API key

Vue.prototype.$apikeyname = "hubspot_contact_id"
// localStorage.setItem("hubspot_contact_id", "32180601")
// localStorage.setItem("hubspot_contact_id", "")

// Import Components

import components from "./modules/components"
Vue.use(components)

// Vue Good Table

import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);

// Vue Forumulate

import VueFormulate from '@braid/vue-formulate'
Vue.use(VueFormulate)

// Vue Calendar

import VCalendar from 'v-calendar';
Vue.use(VCalendar, {
  componentPrefix: 'v',
});


// Vue Toast

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

Vue.use(VueToast, {
  position: 'top',
  duration: 2000
})

// Tooltip
import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
  themes: {
    tooltip: {
      placement: "right"
    }
  }
})

// Import Styles

import "bootstrap/dist/css/bootstrap-grid.min.css";
import "@braid/vue-formulate/dist/snow.min.css";
import "./modules/main.css"
import 'v-tooltip/dist/v-tooltip.css'

// Vuex

import store from "./store"

Vue.mixin({
  computed: {
    apidata: () => {
      return store.state.apidata
    }
  }
})

// Vue Router

import router from './router'

// Axios

import axios from 'axios'
Vue.prototype.$axios = axios;

// Mount Vue

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')